import styled from "@emotion/styled";
import { display, DisplayProps, layout, LayoutProps, space, SpaceProps } from "styled-system";

type SpacerProps = SpaceProps & DisplayProps & LayoutProps;

const Spacer = styled.div<SpacerProps>`
  ${display};
  ${space};
  ${layout};
`;
//prevent margin collapsing
// Spacer.defaultProps = { display: 'inline-block' }

export default Spacer;
